// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Reactions__container-d1b1c9 {
  overflow: hidden;
}

.Reactions__content-e88ca1 {
  display: flex;
  justify-content: var(--content-align);
  align-items: center;
  flex-wrap: wrap;
  margin-top: var(--content-margin-top);
  margin-bottom: var(--content-margin-bottom);
  margin-inline-start: var(--content-margin-inline-start);
  margin-inline-end: var(--content-margin-inline-end);
}

.Reactions__reaction-container-a3c2b6 {
  flex-shrink: 0;
}

.Reactions__reaction-ba72d2 {
  margin-top: var(--reaction-margin-top);
  margin-bottom: var(--reaction-margin-bottom);
  margin-inline-start: var(--reaction-margin-inline-start);
  margin-inline-end: var(--reaction-margin-inline-end);
}

.Reactions__theme-1-f5bf26,
.Reactions__theme-3-bf280a {
  --content-align: flex-start;
  --content-margin-top: 0px;
  --content-margin-bottom: -4px;
  --content-margin-inline-start: 0px;
  --content-margin-inline-end: 0px;
  --reaction-margin-top: 0px;
  --reaction-margin-bottom: 4px;
  --reaction-margin-inline-start: 0px;
  --reaction-margin-inline-end: 4px;
}

.Reactions__theme-2-ad430d,
.Reactions__theme-4-ac9a14 {
  --content-align: flex-end;
  --content-margin-top: 0px;
  --content-margin-bottom: -4px;
  --content-margin-inline-start: 0px;
  --content-margin-inline-end: 0px;
  --reaction-margin-top: 0px;
  --reaction-margin-bottom: 4px;
  --reaction-margin-inline-start: 4px;
  --reaction-margin-inline-end: 0px;
}

.Reactions__theme-6-a69074 {
  --content-align: flex-start;
  --content-margin-top: 0px;
  --content-margin-bottom: -7px;
  --content-margin-inline-start: 0px;
  --content-margin-inline-end: 0px;
  --reaction-margin-top: 0px;
  --reaction-margin-bottom: 7px;
  --reaction-margin-inline-start: 0px;
  --reaction-margin-inline-end: 7px;
}`, "",{"version":3,"sources":["webpack://./src/components/Reactions/Reactions.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,eAAA;EACA,qCAAA;EACA,2CAAA;EACA,uDAAA;EACA,mDAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,sCAAA;EACA,4CAAA;EACA,wDAAA;EACA,oDAAA;AACF;;AAEA;;EAEE,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,kCAAA;EACA,gCAAA;EACA,0BAAA;EACA,6BAAA;EACA,mCAAA;EACA,iCAAA;AACF;;AAEA;;EAEE,yBAAA;EACA,yBAAA;EACA,6BAAA;EACA,kCAAA;EACA,gCAAA;EACA,0BAAA;EACA,6BAAA;EACA,mCAAA;EACA,iCAAA;AACF;;AAEA;EACE,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,kCAAA;EACA,gCAAA;EACA,0BAAA;EACA,6BAAA;EACA,mCAAA;EACA,iCAAA;AACF","sourcesContent":[".container {\n  overflow: hidden;\n}\n\n.content {\n  display: flex;\n  justify-content: var(--content-align);\n  align-items: center;\n  flex-wrap: wrap;\n  margin-top: var(--content-margin-top);\n  margin-bottom: var(--content-margin-bottom);\n  margin-inline-start: var(--content-margin-inline-start);\n  margin-inline-end: var(--content-margin-inline-end);\n}\n\n.reaction-container {\n  flex-shrink: 0;\n}\n\n.reaction {\n  margin-top: var(--reaction-margin-top);\n  margin-bottom: var(--reaction-margin-bottom);\n  margin-inline-start: var(--reaction-margin-inline-start);\n  margin-inline-end: var(--reaction-margin-inline-end);\n}\n\n.theme-1,\n.theme-3 {\n  --content-align: flex-start;\n  --content-margin-top: 0px;\n  --content-margin-bottom: -4px;\n  --content-margin-inline-start: 0px;\n  --content-margin-inline-end: 0px;\n  --reaction-margin-top: 0px;\n  --reaction-margin-bottom: 4px;\n  --reaction-margin-inline-start: 0px;\n  --reaction-margin-inline-end: 4px;\n}\n\n.theme-2,\n.theme-4 {\n  --content-align: flex-end;\n  --content-margin-top: 0px;\n  --content-margin-bottom: -4px;\n  --content-margin-inline-start: 0px;\n  --content-margin-inline-end: 0px;\n  --reaction-margin-top: 0px;\n  --reaction-margin-bottom: 4px;\n  --reaction-margin-inline-start: 4px;\n  --reaction-margin-inline-end: 0px;\n}\n\n.theme-6 {\n  --content-align: flex-start;\n  --content-margin-top: 0px;\n  --content-margin-bottom: -7px;\n  --content-margin-inline-start: 0px;\n  --content-margin-inline-end: 0px;\n  --reaction-margin-top: 0px;\n  --reaction-margin-bottom: 7px;\n  --reaction-margin-inline-start: 0px;\n  --reaction-margin-inline-end: 7px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Reactions__container-d1b1c9`,
	"content": `Reactions__content-e88ca1`,
	"reaction-container": `Reactions__reaction-container-a3c2b6`,
	"reactionContainer": `Reactions__reaction-container-a3c2b6`,
	"reaction": `Reactions__reaction-ba72d2`,
	"theme-1": `Reactions__theme-1-f5bf26`,
	"theme1": `Reactions__theme-1-f5bf26`,
	"theme-3": `Reactions__theme-3-bf280a`,
	"theme3": `Reactions__theme-3-bf280a`,
	"theme-2": `Reactions__theme-2-ad430d`,
	"theme2": `Reactions__theme-2-ad430d`,
	"theme-4": `Reactions__theme-4-ac9a14`,
	"theme4": `Reactions__theme-4-ac9a14`,
	"theme-6": `Reactions__theme-6-a69074`,
	"theme6": `Reactions__theme-6-a69074`
};
module.exports = ___CSS_LOADER_EXPORT___;
